<template>
    <div data-test="applications-closed">
        <!-- ToolTip's trigger wrapper is inline; stretch it so the button fills the card. -->
        <div class="[&>div]:flex [&>div]:w-full">
            <!-- ToolTip's trigger is focusable with role="button"; its label says the control is closed
                 so screen readers don't announce a working apply button. -->
            <ToolTip title="Not Available">
                <template #trigger>
                    <span
                        class="flex w-full cursor-not-allowed items-center justify-center rounded-lg bg-gray-200 px-4 py-3 text-sm font-semibold text-gray-500"
                        aria-hidden="true"
                        data-test="closed-label"
                    >
                        {{ label }}
                    </span>
                </template>
                <p class="rounded border border-gray-300 bg-white p-3 text-sm text-gray-700">{{ message }}</p>
            </ToolTip>
        </div>
        <p class="sr-only">{{ message }}</p>
        <p v-if="note" class="mt-3 text-sm text-gray-600">{{ note }}</p>
    </div>
</template>

<script setup>
import ToolTip from '@/Shared/ToolTip.vue'

defineProps({
    label: {
        type: String,
        default: 'Apply Now',
    },
    message: {
        type: String,
        default: 'Not currently accepting rental applications.',
    },
    note: {
        type: String,
        default: '',
    },
})
</script>
